import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import LegalContent from "../components/legal/legalContent"

export const TermsPageTemplate = ({
  data: {
    markdownRemark: {
      frontmatter: { slug, title, description, copy },
    },
  },
}) => {
  return (
    <Layout>
      <SEO title={title} description={description} pathname={slug} />
      <LegalContent copy={copy} />
    </Layout>
  )
}

export default TermsPageTemplate

export const pageQuery = graphql`
  query TermsPageTemplate {
    markdownRemark(frontmatter: { templateKey: { eq: "terms-page" } }) {
      frontmatter {
        slug
        title
        description
        copy
      }
    }
  }
`
